import { Record as record } from 'immutable';

import { construct, fields, resolve } from '../../helpers/LinkMapper';
import Station from '../Station';

const defaults = {
    id: null,
    brand: null,
    destination: new Station(),
    orderId: null,
    origin: new Station(),
    purchaseDateTime: null,
    ticketId: null,
    ticketNumber: null,
    ticketTypeCode: null,
    validFromDate: null,
    validityPeriod: null,
    validToDate: null,
    status: null,
    isFlexi: false
};

export default class STicket extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(STicket, json, {
            id: fields.string,
            brand: fields.string,
            destination: resolve.as(Station),
            orderId: fields.string,
            origin: resolve.as(Station),
            purchaseDateTime: fields.datetime,
            ticketId: fields.string,
            ticketNumber: fields.string,
            ticketTypeCode: fields.string,
            validFromDate: fields.datetime,
            validityPeriod: fields.string,
            validToDate: fields.datetime,
            status: fields.string,
            isFlexi: fields.bool
        });
    }
}
